import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatMenuModule } from '@angular/material/menu';

import { EditImageToolsModule } from '../edit-image-tools/edit-image-tools.module';
import { ContextMenuComponent } from './context-menu.component';
import { ContextMenuService } from './context-menu.service';

@NgModule({
  imports: [CommonModule, MatMenuModule, EditImageToolsModule, OverlayModule],
  exports: [],
  declarations: [ContextMenuComponent],
  providers: [ContextMenuService],
})
export class ContextMenuModule { 
  static forRoot(): ModuleWithProviders<ContextMenuModule> {
    return {
      ngModule: ContextMenuModule,
      providers: [ContextMenuService]
    };
  }
}
